module.exports = __webpack_public_path__ + "static/featuredFont-a5720be08e52c704a46c193842fe6747.svg";